import { deleteJourney } from '@state/builders/journeys/helpers'
import { deleteJourneyLeg } from '@state/builders/journey-legs/helpers'
import { getJourneysWithLegsByDirections } from '@state/queries/journeys/get-journeys-by-directions.js'

export const deleteJourneysByDirections = (directions) => {
  getJourneysWithLegsByDirections(directions).forEach((journey) => {
    journey.legs.forEach((leg) => deleteJourneyLeg(leg.id))

    deleteJourney(journey.id)
  })
}
